import { useEffect } from 'react';
import { calcularCotizacion } from '@/lib/calc';
import { determinarSubmarca } from '@/lib/utils';

/**
 * Hook que mantiene los totales y submarca sincronizados con el resto del quote.
 * Se ejecuta cada vez que cambian los productos, descuentos, licencia o ajuste.
 */
export function useQuoteCalc(quote, setQuote) {
  // Recalcular totales
  useEffect(() => {
    const { subtotal, descuentoTotal, descuentoPct, total } = calcularCotizacion(quote);
    const submarca = quote.submarcaManual
      ? quote.submarca
      : determinarSubmarca(quote.productos);

    setQuote((q) => ({ ...q, subtotal, descuentoTotal, descuentoPct, total, submarca }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    JSON.stringify(quote.productos),
    quote.descuentos.bundle,
    quote.descuentos.elementosPrevios,
    JSON.stringify(quote.descuentos.codigos),
    quote.pago.licenciaPrepagada,
    quote.ajusteManual,
    quote.submarcaManual,
    quote.submarca,
  ]);

  // Auto-bundle con 4+ productos
  useEffect(() => {
    if (quote.productos.length >= 4 && !quote.descuentos.bundle) {
      setQuote((q) => ({ ...q, descuentos: { ...q.descuentos, bundle: true } }));
    }
    if (quote.productos.length < 4 && quote.descuentos.bundle) {
      setQuote((q) => ({ ...q, descuentos: { ...q.descuentos, bundle: false } }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quote.productos.length]);
}
